<body data-gr-c-s-loaded="true">
    <div id="page" class="side-nav-wrapper">

        <div id="get-quote" class="vtop-logo get-a-quote black text-center lt-bg-blue">
            <div class="container">
                <div class="row">
                    <div class="col-md-2 pull-right" style="margin-right: 10px;">
                        <div class="dropdown">
                            <button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown"
                                style="background:transparent; margin-bottom: 10px;">{{userDetails.FirstName}}&nbsp;{{userDetails.LastName}}
                                <span class="caret"></span></button>
                            <ul class="dropdown-menu">
                                <li><a [routerLink]="" (click)="changePassword()" class="">Change Password</a></li>
                                <li><a [routerLink]="" (click)="logout()" class="">Logout</a></li>
                                <li *ngIf="userDetails.Roles[0].Role == 'SUPERADMIN' ||
                                    userDetails.Roles[0].Role == 'ADMIN'"><a [routerLink]="" (click)="Settings()"
                                        class="">Settings</a></li>
                                <li
                                    *ngIf="userDetails.Roles[0].Role == 'SUPERADMIN' || userDetails.Roles[0].Role =='ADMIN'">
                                    <a [routerLink]="" (click)="users()" class="">Users</a></li>

                            </ul>
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <div class="container bg-gray">
            <div class="row">
                <div class="col-md-12">
                    <h5 class="dr-sub-head">Create Appointments</h5>
                </div>
            </div>
            <div class="row orr-usercreation ptop30 pbtom30">

                <div class="col-md-12">
                    <div class="panel">
                        <h5>Create Appointments</h5>


                        <div class="tab-table-customer-entry"
                            style="margin:30px 0;background:#fff;padding:10px 0;border-top:1px solid #ddd;border-bottom:1px solid #ddd;">


                            <form id="contact-form" class="contact-form pad-40" autocomplete="off"
                                [formGroup]="appointmentForm">
                                <div class="form-pad-label" style="padding-top:30px;">

                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Phone
                                                Number<span class="required"> * </span></label>
                                            <input
                                                [class.is-invalid]="ContactNumber.invalid && (ContactNumber.dirty || ContactNumber.touched)"
                                                class="form-control" id="ContactNumber" type="ContactNumber"
                                                name="ContactNumber" placeholder=" Phone Number "
                                                formControlName="ContactNumber" required #mynumber
                                                (change)="onPhoneEntered(mynumber.value)">

                                        </div>

                                        <div style="text-align: center;">
                                            <small *ngIf="error && ContactNumber.errors?.required"
                                                class="text-danger">Phone
                                                Number is
                                                required</small>
                                            <small *ngIf="error && ContactNumber.errors?.pattern"
                                                class="text-danger">Please
                                                enter valid Phone Number</small>
                                            <small *ngIf="error && ContactNumber.errors?.minlength"
                                                class="text-danger">Phone
                                                Number should be 10 digits</small>
                                            <small *ngIf="error && ContactNumber.errors?.maxlength"
                                                class="text-danger">Phone
                                                Number should be 10 digits</small>

                                        </div>
                                    </div>

                                    <div class="col-md-8" *ngIf="PatientDetiails && PatientDetiails.length>0">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">list
                                                Of Patients<span class="required"> * </span></label>
                                            <select
                                                class="way-custom-dropdown price-text-field profile-mwidth form-control"
                                                style="background-color:#fff;margin-bottom:20px;"
                                                formControlName="CMRNumber" id="CMRNumber" name="CMRNumber" required=""
                                                required #patientSelect
                                                (change)='onPatientSelectSelected(patientSelect.value)'>
                                                <option value="" disabled>Select Patient</option>

                                                <option *ngFor="let pt of PatientDetiails; let i=index"
                                                    value="{{pt.MRNumber}}">{{pt.Name}}</option>
                                                <option value="NewCustomer">--New Patient--</option>
                                            </select>
                                        </div>
                                        <div style="text-align: center;">
                                            <small *ngIf="error && CMRNumber.errors?.required"
                                                class="text-danger">Select Patient
                                            </small>
                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Patient
                                                Name {{mrnum}}<span class="required"> * </span></label>
                                            <input
                                                [class.is-invalid]="PatientName.invalid && (PatientName.dirty || PatientName.touched)"
                                                class="form-control" id="PatientName" type="PatientName"
                                                name="PatientName" placeholder=" PatientName "
                                                formControlName="PatientName" [readonly]="isReadonly">

                                        </div>
                                        <div style="text-align: center;">
                                            <small *ngIf="error && PatientName.errors?.required"
                                                class="text-danger">PatientName is
                                                required</small>
                                            <small *ngIf="error && PatientName.errors?.minlength"
                                                class="text-danger">PatientName
                                                should be minimum 3 characters
                                            </small>
                                            <small *ngIf="error && PatientName.errors?.pattern"
                                                class="text-danger">PatientName
                                                must be alphabets </small>

                                        </div>
                                    </div>
                                    <div style="clear:both;"></div>

                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Age<span
                                                    class="required"> * </span></label>
                                            <input [class.is-invalid]="Age.invalid && (Age.dirty || Age.touched)"
                                                class="form-control" id="Age" type="text" name="Age" placeholder=" Age "
                                                formControlName="Age" [readonly]="isReadonly">

                                        </div>
                                        <div style="text-align: center;">
                                            <small *ngIf="error && Age.errors?.required" class="text-danger">Age is
                                                required</small>
                                            <small *ngIf="error && Age.errors?.pattern" class="text-danger">Age must be
                                                two
                                                digits </small>

                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Gender<span
                                                    class="required"> * </span></label>
                                            <select
                                                class="way-custom-dropdown price-text-field profile-mwidth form-control"
                                                style="background-color:#fff;margin-bottom:20px;"
                                                formControlName="Gender" id="Gender" name="Gender" required="">
                                                <option value="" disabled>Select Gender</option>

                                                <option value="Male" [disabled]="isDisabled">Male</option>
                                                <option value="Female" [disabled]="isDisabled">Female</option>


                                            </select>

                                        </div>
                                        <div style="text-align: center;">
                                            <small *ngIf="error && Gender.errors?.required" class="text-danger">Gender
                                                is
                                                required</small>

                                        </div>
                                    </div>
                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Appointment
                                                Type<span class="required"> </span></label>
                                            <select
                                                class="way-custom-dropdown price-text-field profile-mwidth form-control"
                                                style="background-color:#fff;margin-bottom:20px;"
                                                formControlName="AppointmentType" id="AppointmentType"
                                                name="AppointmentType">
                                                <option value="" disabled>Select Appointment Type</option>

                                                <option value="Appointment">Appointment</option>
                                                <option value="FollowUpVisit">FollowUpVisit</option>
                                                <option value="FreeVisit">FreeVisit</option>


                                            </select>

                                        </div>
                                    </div>
                                    <div class="col-md-8" *ngIf="viewalldoctors?.data.length > 1 ">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Doctor
                                                Name<span class="required"> * </span></label>
                                            <select
                                                class="way-custom-dropdown price-text-field profile-mwidth form-control"
                                                style="background-color:#fff;margin-bottom:20px;"
                                                formControlName="DoctorID" id="DoctorID" name="DoctorID" required
                                                #mySelect (change)='onOptionsSelected(mySelect.value)'>
                                                <option value="" disabled>Select Doctor's Name</option>

                                                <option *ngFor="let list of viewalldoctors?.data; let i=index"
                                                    value="{{list.MedicID}}">{{list.FirstName}}</option>
                                            </select>

                                        </div>
                                        <div style="text-align: center;">
                                            <small *ngIf="error && DoctorID.errors?.required"
                                                class="text-danger">Doctor's
                                                Name is
                                                required</small>
                                        </div>
                                    </div>
                                    <div style="clear:both;"></div>
                                    <div class="col-md-8" *ngIf="viewallhospitals?.data.length > 1 ">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Hospital<span
                                                    class="required"> * </span></label>
                                            <select
                                                class="way-custom-dropdown price-text-field profile-mwidth form-control"
                                                style="background-color:#fff;margin-bottom:20px;"
                                                formControlName="HospitalID" id="HospitalID" name="HospitalID" required
                                                #mySelecthospital
                                                (change)='onOptionsSelectedhospital(mySelecthospital.value)'>
                                                <option value="" disabled>Select Hospital</option>

                                                <option *ngFor="let list of viewallhospitals?.data; let i=index"
                                                    value="{{list.HospitalID}}">{{list.HospitalName}}</option>


                                            </select>

                                        </div>
                                        <div style="text-align: center;">
                                            <small *ngIf="error && HospitalID.errors?.required"
                                                class="text-danger">Hospital
                                                is
                                                required</small>

                                        </div>
                                    </div>
                                    <div style="clear:both;"></div>
                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Appointment
                                                Date <span class="required"> * </span></label>

                                            <div class="input-group date">
                                                <input type='text' class="form-control" placeholder="dd-mm-yyyy"
                                                    formControlName="Date" id="Date" name="Date" #dp="bsDatepicker"
                                                    bsDatepicker [bsConfig]="datePickerConfig" placement="right"
                                                    style="width: 430px;" [minDate]="minDate">
                                                <span class="input-group-addon">
                                                    <i class="glyphicon glyphicon-calendar" (click)="dp.toggle()"></i>
                                                </span>

                                            </div>
                                            <div style="text-align: center;">
                                                <small *ngIf="error && Date.errors?.required"
                                                    class="text-danger">Appointment Date
                                                    is
                                                    required</small>

                                            </div>

                                        </div>

                                    </div>
                                    <!-- <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Time<span
                                                    class="required"> * </span></label>
                                            <input [class.is-invalid]="Time.invalid && (Time.dirty || Time.touched)"
                                                class="form-control" id="Time" type="time" name="Time"
                                                placeholder=" Time " formControlName="Time">
                                            <div *ngIf="Time.invalid  && (Time.dirty || Time.touched)">
                                                <small *ngIf="Time.errors?.required" class="text-danger">Time is
                                                    required</small>

                                            </div>
                                        </div>
                                    </div> -->
                                    <!-- <div style="clear:both;"></div> -->
                                    <!-- <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Fee<span
                                                    class="required"> * </span></label>
                                            <input [class.is-invalid]="Fee.invalid && (Fee.dirty || Fee.touched)"
                                                class="form-control" id="Fee" type="Fee" name="Fee" placeholder=" Fee "
                                                formControlName="Fee" readonly>
                                            <div *ngIf="Fee.invalid  && (Fee.dirty || Fee.touched)">
                                                <small *ngIf="Fee.errors?.required" class="text-danger">Fee is
                                                    required</small>
                                                <small *ngIf="Fee.errors?.pattern" class="text-danger">Fee must be
                                                    number </small>

                                            </div>
                                        </div>
                                    </div> -->
                                    <!-- <div style="clear:both;"></div>
                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Discount<span
                                                    class="required"> </span></label>
                                            <input [class.is-invalid]="Discount.invalid && (Fee.dirty || Fee.touched)"
                                                class="form-control" id="Discount" type="Discount" name="Discount"
                                                placeholder=" Discount " formControlName="Discount" readonly>
                                            <div *ngIf="Discount.invalid  && (Discount.dirty || Discount.touched)">
                                                <small *ngIf="Discount.errors?.pattern" class="text-danger">Discount
                                                    must be number </small>

                                            </div>
                                        </div>
                                    </div> -->
                                    <!-- <div style="clear:both;"></div> -->
                                    <!-- <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Payment
                                                Status<span class="required"> * </span></label>
                                            <select
                                                class="way-custom-dropdown price-text-field profile-mwidth form-control"
                                                style="background-color:#fff;margin-bottom:20px;"
                                                formControlName="PaymentStatus" id="PaymentStatus" name="PaymentStatus"
                                                required="">
                                                <option value="">Select PaymentStatus</option>

                                                <option value="Paid">Paid</option>
                                                <option value="NotPaid">Not Paid</option>


                                            </select>
                                            <div
                                                *ngIf="PaymentStatus.invalid  && (PaymentStatus.dirty || PaymentStatus.touched)">
                                                <small *ngIf="PaymentStatus.errors?.required"
                                                    class="text-danger">PaymentStatus is
                                                    required</small>

                                            </div>
                                        </div>
                                    </div> -->
                                    <!-- <div style="clear:both;"></div> -->
                                    <div style="clear:both;"></div>
                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label style="width:180px;float:left;text-align:right;padding-right:15px;">
                                                Address<span class="required"> * </span></label>
                                            <input
                                                [class.is-invalid]="StreetAddress.invalid && (StreetAddress.dirty || StreetAddress.touched)"
                                                class="form-control" id="StreetAddress" type="StreetAddress"
                                                name="StreetAddress" placeholder=" Street Address "
                                                formControlName="StreetAddress" [readonly]="isReadonly">

                                        </div>
                                        <div style="text-align: center;">
                                            <small *ngIf="error && StreetAddress.errors?.required" class="text-danger">
                                                Address is required</small>

                                        </div>
                                    </div>

                                    <div style="clear:both;"></div>
                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label style="width:180px;float:left;text-align:right;padding-right:15px;">
                                                District<span class="required"> * </span></label>
                                            <input
                                                [class.is-invalid]="District.invalid && (District.dirty || District.touched)"
                                                class="form-control" id="District" type="District" name="District"
                                                placeholder=" District " formControlName="District"
                                                [readonly]="isReadonly">

                                        </div>
                                        <div style="text-align: center;">
                                            <small *ngIf="error && District.errors?.required"
                                                class="text-danger">District is
                                                required</small>

                                        </div>
                                    </div>

                                    <div style="clear:both;"></div>
                                    <div
                                        style="margin:auto;text-align:center;margin-bottom:10px;margin-top:30px;margin-bottom:30px;">
                                        <a [routerLink]="" (click)="onSubmit(appointmentForm)"> <input type="submit"
                                                class="btn-pink" value="CREATE"></a>

                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>
<ngx-spinner></ngx-spinner>



<!-- <div style="clear:both;"></div>
                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Colony
                                                <span class="required"> * </span></label>
                                            <input
                                                [class.is-invalid]="Colony.invalid && (Colony.dirty || Colony.touched)"
                                                class="form-control" id="Colony" type="Colony" name="Colony"
                                                placeholder=" Colony " formControlName="Colony">
                                            <div *ngIf="Colony.invalid  && (Colony.dirty || Colony.touched)">
                                                <small *ngIf="Colony.errors?.required" class="text-danger">Colony is
                                                    required</small>

                                            </div>
                                        </div>
                                    </div>
                                    <div style="clear:both;"></div>
                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Locality
                                                <span class="required"> * </span></label>
                                            <input
                                                [class.is-invalid]="Locality.invalid && (Locality.dirty || Locality.touched)"
                                                class="form-control" id="Locality" type="Locality" name="Locality"
                                                placeholder=" Locality " formControlName="Locality">
                                            <div *ngIf="Locality.invalid  && (Locality.dirty || Locality.touched)">
                                                <small *ngIf="Locality.errors?.required" class="text-danger">Locality is
                                                    required</small>

                                            </div>
                                        </div>
                                    </div>
                                    <div style="clear:both;"></div>

                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">City
                                                <span class="required"> * </span></label>
                                            <input [class.is-invalid]="City.invalid && (City.dirty || City.touched)"
                                                class="form-control" id="City" type="City" name="City"
                                                placeholder=" City " formControlName="City">
                                            <div *ngIf="City.invalid  && (City.dirty || City.touched)">
                                                <small *ngIf="City.errors?.required" class="text-danger">City is
                                                    required</small>

                                            </div>
                                        </div>
                                    </div>
                                    <div style="clear:both;"></div>
                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">PinCode
                                                <span class="required"> * </span></label>
                                            <input
                                                [class.is-invalid]="PinCode.invalid && (PinCode.dirty || PinCode.touched)"
                                                class="form-control" id="PinCode" type="PinCode" name="PinCode"
                                                placeholder=" PinCode " formControlName="PinCode">
                                            <div *ngIf="PinCode.invalid  && (PinCode.dirty || PinCode.touched)">
                                                <small *ngIf="PinCode.errors?.required" class="text-danger">PinCode is
                                                    required</small>
                                                <small *ngIf="PinCode.errors?.pattern" class="text-danger">please enter
                                                    valid PinCode</small>


                                            </div>
                                        </div>
                                    </div>
                                    <div style="clear:both;"></div>
                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">State
                                                <span class="required"> * </span></label>
                                            <input [class.is-invalid]="State.invalid && (State.dirty || State.touched)"
                                                class="form-control" id="State" type="State" name="State"
                                                placeholder=" State " formControlName="State">
                                            <div *ngIf="State.invalid  && (State.dirty || State.touched)">
                                                <small *ngIf="State.errors?.required" class="text-danger">State is
                                                    required</small>

                                            </div>
                                        </div>
                                    </div>
                                    <div style="clear:both;"></div>
                                    <div class="col-md-8">
                                        <div class="input-text form-group has-feedback">
                                            <label
                                                style="width:180px;float:left;text-align:right;padding-right:15px;">Country
                                                <span class="required"> * </span></label>
                                            <input
                                                [class.is-invalid]="Country.invalid && (Country.dirty || Country.touched)"
                                                class="form-control" id="Country" type="Country" name="Country"
                                                placeholder=" Country " formControlName="Country">
                                            <div *ngIf="Country.invalid  && (Country.dirty || Country.touched)">
                                                <small *ngIf="Country.errors?.required" class="text-danger">Country is
                                                    required</small>

                                            </div>
                                        </div>
                                    </div> -->